const normaliseInteger = (value: string) => value.replace(/[^\d]/gi, "") || "";
const normaliseAlphanumeric = (value: string) => value.replace(/[^\da-z]/gi, "") || "";
const normaliseAlphanumericUnderscore = (value: string) => value.replace(/[^\da-z_]/gi, "") || "";
const normaliseFullyQualifiedName = (value: string) => value.replace(/[^\da-z- ",.]/gi, "") || "";
const normaliseName = (value: string) => value.replace(/[^\da-z- ]/gi, "") || "";
const normaliseNameWithoutHyphen = (value: string) => value.replace(/[^\da-z ]/gi, "") || "";
const normaliseUrl = (value: string) => value.replace(/[^\da-z-:/.]/gi, "") || "";

export {
  normaliseInteger,
  normaliseAlphanumeric,
  normaliseFullyQualifiedName,
  normaliseName,
  normaliseUrl,
  normaliseAlphanumericUnderscore,
  normaliseNameWithoutHyphen
};
